import { Activity } from "PFTypes";

import css from "./footer.module.scss";

interface FooterProps {
  participants?: Activity["participants"];
}

export const Footer = ({ participants }: FooterProps) =>
  participants &&
  participants.length > 0 && (
    <div className={css.wrapper}>
      <div className={css.right}>{`${participants.length} Discussing`}</div>
    </div>
  );
